import(/* webpackMode: "eager" */ "/vercel/path0/src/app/liquidity/components/bid-and-ask.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/liquidity/components/dex.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/liquidity/components/table.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/liquidity/components/toke-pairs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/liquidity/components/total-liquidity.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/liquidity/components/variation.tsx");
